// extracted by mini-css-extract-plugin
module.exports = {"label":"ToggleSwitch_label__3PqYP","toggle":"ToggleSwitch_toggle__QNChF","right":"ToggleSwitch_right__2aiSk","left":"ToggleSwitch_left__Hklqi","input":"ToggleSwitch_input__XvNeZ"};